import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Repositories from './pages/Repositories';
import RepositoryDetail from './pages/RepositoryDetail';
import AccessRequests from './pages/AccessRequests';
import VerifyMFA from './pages/VerifyMFA';
import ForcePasswordChange from './pages/ForcePasswordChange';
import Settings from './pages/Settings';
import Notifications from './pages/Notifications';
import AdminLayout from './components/AdminLayout';
import AdminOverview from './pages/AdminOverview';
import UserManagement from './pages/UserManagement';
import ActivityLogs from './pages/ActivityLogs';
import AccessMatrix from './pages/AccessMatrix';
import AccessReviews from './pages/AccessReviews';
import GitHubIntegrations from './pages/GitHubIntegrations';
import AccessPolicies from './pages/AccessPolicies';
import SecurityCenter from './pages/SecurityCenter';
import AnalyticsDashboard from './pages/AnalyticsDashboard';
import JobsDashboard from './pages/JobsDashboard';
import './App.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function OAuthAuthorizeRedirect() {
  useEffect(() => {
    window.location.replace(`${API_URL}/auth/github`);
  }, []);
  return null;
}

function AppContent() {
  const { user } = useAuth();
  const location = useLocation();
  const isLanding = location.pathname === '/';
  const isAdmin = location.pathname.startsWith('/admin');
  const signedIn = Boolean(user);
  return (
    <div className={signedIn ? 'app-shell' : 'app-public'}>
      <Navbar />
      <main className={`main-content${isLanding ? ' main-content--landing' : ''}${isAdmin ? ' main-content--admin' : ''}`}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/login/oauth/authorize" element={<OAuthAuthorizeRedirect />} />
          <Route path="/verify-mfa" element={<VerifyMFA />} />
          <Route path="/force-password-change" element={<ForcePasswordChange />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/repositories" element={<Repositories />} />
          <Route path="/repositories/:owner/:repo" element={<RepositoryDetail />} />
          <Route path="/access-requests" element={<AccessRequests />} />
          <Route path="/access-reviews" element={<AccessReviews />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminOverview />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="repositories" element={<Repositories />} />
            <Route path="access-requests" element={<AccessRequests />} />
            <Route path="activity-logs" element={<ActivityLogs />} />
            <Route path="access-matrix" element={<AccessMatrix />} />
            <Route path="access-reviews" element={<AccessReviews />} />
            <Route path="integrations" element={<GitHubIntegrations />} />
            <Route path="policies" element={<AccessPolicies />} />
            <Route path="security" element={<SecurityCenter />} />
            <Route path="analytics" element={<AnalyticsDashboard />} />
            <Route path="jobs" element={<JobsDashboard />} />
          </Route>
        </Routes>
      </main>
    </div>
  );
}

function App() {
  useEffect(() => {
    const saved = localStorage.getItem('theme');
    if (saved === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    }
  }, []);

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <AppContent />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
